export class Swipe {
  constructor (element, slidePrev, slideNext, settings) {
    this.element = element
    // this.element = slider
    this.slidePrev = slidePrev
    this.slideNext = slideNext
    this.offset = 0
    this.resetSettings(settings)
  }
  unregister () {
    this.element.removeEventListener('touchstart', events, false, { passive: true })
    if (this.draggable) {
      this.element.removeEventListener('mousedown', events, false)
      this.element.removeEventListener('mouseenter', events, false)
    }
    if (this.infinite) {
      this.element.removeEventListener('webkitTransitionEnd', events, false)
      this.element.removeEventListener('msTransitionEnd', events, false)
      this.element.removeEventListener('oTransitionEnd', events, false)
      this.element.removeEventListener('otransitionend', events, false)
      this.element.removeEventListener('transitionend', events, false)
    }
  }
  setup () {
    if (window.addEventListener) {
      _this[this.element.id] = this
      // console.log('swipe setup ...')
      const style = this.element?.style
      updateTransitionDuration(style, this.speed, this.timingFunction)

      this.element.addEventListener('touchstart', events, false, { passive: true })

      if (this.draggable) {
        this.element.addEventListener('mousedown', events, false)
        this.element.addEventListener('mouseenter', events, false)
      }
      if (this.infinite) {
        this.element.addEventListener('webkitTransitionEnd', events, false)
        this.element.addEventListener('msTransitionEnd', events, false)
        this.element.addEventListener('oTransitionEnd', events, false)
        this.element.addEventListener('otransitionend', events, false)
        this.element.addEventListener('transitionend', events, false)
      }
      if (this.autoPlay) {
        setTimeout(() => this.startAutoPlay(), this.autoPlayInterval)
      }
    }
  }

  resetSettings (settings) {
    // default settings
    this.speed = 500 // unit: ms
    this.validDuration = 250
    this.preventScroll = false // won't prevent vertical scrolling by default
    this.draggable = true
    this.timingFunction = 'linear'
    if (settings) {
      const {
        speed, preventScroll, validDuration, draggable, linkClassName,
        autoPlay, autoPlaySpeed, autoPlayInterval, stopOnInteraction,
        infinite, updateCallback, swapClassName, timingFunction,
        translateCallback, boundary
      } = settings
      this.speed = speed || this.speed
      this.validDuration = validDuration || this.validDuration
      this.preventScroll = preventScroll || this.preventScroll
      this.draggable = draggable || this.draggable
      this.linkClassName = linkClassName
      this.timingFunction = timingFunction || this.timingFunction
      this.translateCallback = translateCallback
      this.boundary = boundary
      // auto play
      this.autoPlay = autoPlay
      this.autoPlaySpeed = autoPlaySpeed || 1000
      this.autoPlayInterval = autoPlayInterval || 5000
      this.stopOnInteraction = stopOnInteraction || true
      if (infinite) {
        this.infinite = infinite
        this.updateCallback = updateCallback
        this.swapClassName = swapClassName
      }
    }
  }

  eventStart (event) {
    this.stopAutoPlay()
    let touch = null
    if (isMouseEvent(event)) {
      // console.log('event start mousedown...')
      touch = event
    } else {
      touch = event.touches[0]
    }

    if (this.preventScroll) {
      event.preventDefault()
    } else {
      if (isMouseEvent(event)) { event.preventDefault() }

      if (touch.pageX <= 20 || touch.pageX >= window.innerWidth - 20) {
      // prevent swipe to navigate gesture
        // console.log('prevent edge nav')
        event.preventDefault()
      }
    }

    // measure start values
    this.start = {
      // get initial touch coords
      x: touch.pageX,
      y: touch.pageY,
      // store time to determine touch duration
      time: +new Date()
    }
    this.isScrolling = undefined
    this.offset = this.getOffset()
    // console.log('offset : ', this.offset)
    // reset delta and end measurements
    this.delta = {}
    if (isMouseEvent(event)) {
      // console.log('mousedown...start', this.start)
      this.element.style.cursor = 'grabbing'
      this.element.addEventListener('mousemove', events, false)
      this.element.addEventListener('mouseup', events, false)
      this.element.addEventListener('mouseleave', events, false)
    } else {
      this.element.addEventListener('touchmove', events, false, { passive: true })
      this.element.addEventListener('touchend', events, false, { passive: true })
    }
  }

  move (event) {
    let touch = null
    if (isMouseEvent(event)) {
      event.preventDefault()
      // console.log('mouse move...')
      this.isDragging = true
      touch = event
    } else {
      touch = event.touches[0]
    }
    this.delta = {
      x: touch.pageX - this.start.x,
      y: touch.pageY - this.start.y
    }

    // prevent native scrolling
    if (this.preventScroll) {
      preventDefaultEvent(event)
    } else {
      this.checkScroll()
    }

    if (!this.isScrolling) {
      // not vertical scroll, prevent default
      preventDefaultEvent(event)
      // move with the touch
      // console.log('move slide...')
      this.translate(this.delta.x, 0)
    }
  }

  checkScroll () {
    if (typeof this.isScrolling === 'undefined') {
      const absX = Math.abs(this.delta.x)
      const absY = Math.abs(this.delta.y)
      // const res = (absX < 30 && absX < absY) || absX < absY * 2 || absY > 20
      this.isScrolling = absX < absY
      // if (!res) {
      //   console.log('delta -> ', this.delta, 'isScroll => ', res)
      // }
      // console.log('delta -> ', this.delta, 'this.isScrolling => ', this.isScrolling)
      return this.isScrolling
    }
  }

  getDuration () {
    return Number(+new Date() - this.start.time)
  }

  eventEnd (event) {
    // kill touchmove and touchend event listeners until touchstart called again
    if (isMouseEvent(event)) {
      // mouse up
      // console.log('mouseup...')
      if (this.linkClassName) {
        // console.log('linkClassName...', this.linkClassName)
        const links = this.element.getElementsByClassName(this.linkClassName)
        if (this.isDragging) {
          for (const link of links) {
            // console.log('link to add event listener...', link)
            link.addEventListener('click', preventClick)
          }
        } else {
          for (const link of links) {
            link.removeEventListener('click', preventClick)
          }
        }
      }

      this.element.style.cursor = 'grab'
      this.element.removeEventListener('mousemove', events, false)
      this.element.removeEventListener('mouseup', events, false)
      this.element.removeEventListener('mouseleave', events, false)
    } else {
      this.element.removeEventListener('touchmove', events, false, { passive: true })
      this.element.removeEventListener('touchend', events, false, { passive: true })
    }

    // determine slide or not
    const duration = this.getDuration()
    const isDurationValid = this.validDuration > 0 ? Number(duration) < this.validDuration : true
    const isValidSlide =
    isDurationValid && // if slide duration is less than 250ms
    Math.abs(this.delta.x) > 15 && // and if slide amt is greater than 15px
    !this.isScrolling
    // determine direction of swipe (1: backward, -1: forward)
    const direction = Math.abs(this.delta.x) / this.delta.x
    // console.log('touch end...duration', Number(duration))
    // console.log('touch end...delta > 15', Math.abs(this.delta.x) > 15)
    // console.log('touch end...triggered isScrolling', this.isScrolling)
    if (isValidSlide) {
      // console.log('touch end...')
      // trigger callback methods
      this.resetAnimateParam()
      let slided = false
      if (direction < 0) {
        // console.log('going forward')
        slided = this.slideNext()
      } else {
        // console.log('going backward')
        slided = this.slidePrev()
      }
      if (!slided) {
        // console.log('out of boundary')
        // reset translation
        this.translate(0, 500)
      }

      if (this.boundary) {
        const offset = this.getOffset()
        if (offset < this.boundary.min) {
          this.setTranslate(this.boundary.min, 50)
        } else if (offset > this.boundary.max) {
          this.setTranslate(this.boundary.max, 50)
        }
      }

      if (this.stopOnInteraction) {
        this.cancelAutoPlay()
      }
    } else if (this.delta.x) {
      // reset translation
      // console.log('not valid..', duration, this.delta.x)
      this.translate(0, 300)
      if (this.stopOnInteraction) {
        this.cancelAutoPlay()
      }
    }
    if (this.autoPlay) {
      // mainly reset autoplay timer after user interaction
      this.restartAutoPlay()
    }
    this.isDragging = false
  }

  enter () {
    this.element.style.cursor = 'grab'
  }

  transitionend () {
    if (!this.updateCallback) {
      return
    }
    // set transition duration to 0
    const style = this.element?.style
    // swap slides (will update translation)
    const isSwapped = this.updateCallback()
    // console.log('transitionend...')
    if (isSwapped) {
      if (this.swapClassName) {
        const swapElements = this.element.getElementsByClassName(this.swapClassName)
        if (swapElements && swapElements.length > 0) {
          for (const swapElement of swapElements) {
            // console.log('link to add event listener...', link)
            const swapElementStyle = swapElement.style
            updateTransitionDuration(swapElementStyle, 0)
            // add back duration
            setTimeout(() => updateTransitionDuration(swapElementStyle, this.speed, this.timingFunction), 20)
          }
        }
      } else {
        updateTransitionDuration(style, 0)
        // add back duration
        setTimeout(() => this.resetAnimateParam(), 20)
      }
    } else {
      this.resetAnimateParam()
    }
  }

  restartAutoPlay () {
    // console.log('[Swipe] restart autoplay...')
    this.stopAutoPlay()
    this.startAutoPlay()
  }

  stopAutoPlay () {
    // clearTimeout(this.autoTimeout)
    // console.log('stop autoplay...')
    clearInterval(this.autoInterval)
  }

  cancelAutoPlay () {
    // console.log('cancel autoplay...')
    clearInterval(this.autoInterval)
    this.autoPlay = false
  }

  startAutoPlay () {
    if (!this.autoPlay) {
      return
    }
    if (this.autoInterval) {
      // console.log('start autoplay failed, already has one...')
      return
    }
    // console.log('start autoplay')
    const style = this.element?.style
    // this.autoTimeout = setTimeout(() => this.slideNext(), this.autoPlayInterval)
    this.autoInterval = setInterval(() => {
      updateTransitionDuration(style, this.autoPlaySpeed, this.timingFunction)
      this.slideNext()
    }, this.autoPlayInterval)
  }

  translate (dist, speed) {
    const style = this.element?.style
    if (!style) {
      return
    }
    updateTransitionDuration(style, speed, this.timingFunction)

    style.webkitTransform =
    style.msTransform =
    style.MozTransform =
    style.OTransform =
    style.transform = `translateX(${this.offset + dist}px)`
    if (this.translateCallback) {
      this.translateCallback(this.offset + dist)
    }
  }

  setTranslate (translateX, speed) {
    const style = this.element?.style
    if (!style) {
      return
    }
    updateTransitionDuration(style, speed, this.timingFunction)

    style.webkitTransform =
    style.msTransform =
    style.MozTransform =
    style.OTransform =
    style.transform = `translateX(${translateX}px)`
    if (this.translateCallback) {
      this.translateCallback(translateX)
    }
  }

  resetAnimateParam () {
    const style = this.element?.style
    if (!style) {
      return
    }
    // 'transform 0.5s ease-in-out'
    updateTransitionDuration(style, this.speed, this.timingFunction)
  }

  getOffset () {
    const transform = this.element?.style?.transform
    if (!transform) {
      return 0
    }
    const n = transform.replace('translateX(', '')
    return parseInt(n)
  }
}

const _this = {}
const events = (event) => {
  // console.log('event...', event.type)
  const that = getSwipeObject(event)
  if (!that) {
    // eslint-disable-next-line no-console
    console.warn('swipe not registered')
    return
  }
  // console.log('that => ', that)
  switch (event.type) {
    case 'mousedown':
    case 'touchstart': that.eventStart(event); break
    case 'mousemove':
    case 'touchmove': that.move(event); break
    case 'mouseup':
    case 'mouseleave':
    case 'touchendoutside':
    case 'touchend': that.eventEnd(event); break
    // case 'touchcancel': that.eventCancel(event); break
    case 'webkitTransitionEnd':
    case 'msTransitionEnd':
    case 'oTransitionEnd':
    case 'otransitionend':
    case 'transitionend': that.transitionend(event); break
    case 'mouseenter': that.enter(event); break
  }
}

const getSwipeObject = (event) => {
  // console.log('_this => ', _this)
  // console.log('event type => ', event.type)
  const { target } = event
  if (target.id && _this[target.id]) {
    // console.log('id => ', target.id)
    return _this[target.id]
  }
  if (target.offsetParent) {
    // console.log('event target offsetParent => ', target.offsetParent)
    const id = getContainerId(target.offsetParent)
    if (id) {
      return _this[id]
    }
  }

  if (target.parentElement) {
    // console.log('target parentElement => ', target.parentElement)
    const id = getContainerIdViaParentEle(target.parentElement)
    if (id) {
      return _this[id]
    }
  }
  // eslint-disable-next-line no-console
  console.log('not registered target => ', target)
  return null
}

const getContainerId = (container) => {
  if (!container) {
    return null
  }
  if (_this[container.id]) {
    return container.id
  }
  return getContainerId(container.offsetParent)
}

const getContainerIdViaParentEle = (container) => {
  if (!container) {
    return null
  }
  if (_this[container.id]) {
    return container.id
  }
  return getContainerIdViaParentEle(container.parentElement)
}

const updateTransitionDuration = (style, duration, timingFunction) => {
  if (!style) {
    return
  }
  style.webkitTransitionDuration =
  style.MozTransitionDuration =
  style.msTransitionDuration =
  style.OTransitionDuration =
  style.transitionDuration = duration + 'ms'

  if (timingFunction) {
    style.transitionTimingFunction = timingFunction
  }
}

const isMouseEvent = (e) => {
  return /^mouse/.test(e.type)
}

const preventClick = (e) => {
  // console.log('prevent click...')
  e.preventDefault()
  e.stopImmediatePropagation()
}

const preventDefaultEvent = (event) => {
  if (event.cancelable) { event.preventDefault() }
}
